import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AiKnowledgeConfig, RouteCommand } from './interface/config.interface';

export const AI_KNOWLEDGE_CONFIG_TOKEN = new InjectionToken<AiKnowledgeConfig>(
  '[AiKnowledge]: token for configuration',
);

export const ACCOUNT_GROUP_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for accountGroupId',
);

export const MARKET_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for marketId',
);

export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for partnerId',
);

export const MANAGE_KNOWLEDGE_URL_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for manageKnowledgeUrl',
);

export const BUSINESS_PROFILE_URL_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for businessProfileUrl',
);

export const SHOW_BUSINESS_PROFILE_SOURCE_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for showBusinessProfileSource',
);

export const WEB_CHAT_WIDGET_EDIT_ROUTE_TOKEN: InjectionToken<Observable<RouteCommand[]>> = new InjectionToken(
  '[AiKnowledge]: token for webChatWidgetEditRoute',
);
